import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Button from '@material-ui/core/Button'

//styles
import '../assets/css/home.css'

//providers
import { useAuthDataContext } from './../__providers/AuthProvider'

//helpers
import Api from './../__helpers/api'

//images
import passwordIcon from '../assets/images/home/password-icon.png'
import profileIcon from '../assets/images/home/profile-icon.png'
import loader from '../assets/images/contacts/loader.svg'
import brandNoR from '../assets/images/header/brand-no-r.png'


function Home() {
    const [state, setState] = useState({
        loading: false,
        validate: false
    })
    const auth = useAuthDataContext()

    const login = e => {
        loading(true)
        validate(false)

        e.preventDefault()

        const url = 'login'
        const data = new FormData(e.target)

        Api.post(url, data)
            .then(res => {
                if (res.status === 200 && res.data.success) {
                    auth.login(res.data.data.user)
                    window.location.reload()
                }
                else validate(true)
            })
            .catch(() => {
                validate(true)
            })
            .finally(() => {
                loading(false)
            })
    }

    const loading = loading => {
        setState(prev => ({
            ...prev,
            loading
        }))
    }

    const validate = validate => {
        setState(prev => ({
            ...prev,
            validate
        }))
    }



    return (
        <>
            <main id="homeMain">
                <div className="login">
                    <img src={brandNoR} alt="brand" className="brand" />
                    <h2>
                        Вход в Авто Обучение
                    </h2>
                    <p>
                        Моля, въведете Вашите данни за вход.
                    </p>

                    <form onSubmit={login} id="loginForm">
                        <TextField
                            id="outlined-search"
                            type="text"
                            variant="outlined"
                            fullWidth
                            name="email"
                            placeholder="Въведете Е-поща / тел. номер..."
                            className={state.validate ? `error` : ''}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={profileIcon} alt="profile" className={state.validate === true ? 'icons error' : 'icons'} />
                                    </InputAdornment>
                                )
                            }}
                        />
                        <TextField
                            id="outlined-search"
                            type="password"
                            variant="outlined"
                            fullWidth
                            name="password"
                            className={state.validate ? `error` : ''}
                            placeholder="Въведете парола..."
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={passwordIcon} alt="password" className={state.validate === true ? 'icons error' : 'icons'} />
                                    </InputAdornment>
                                )
                            }}
                        />
                        <div className="row">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        value="checkedB"
                                        color="primary"
                                    />
                                }
                                label="Запомни ме"
                            />
                            <span className="forgotten-password">

                            </span>
                        </div>
                        <div className="button-holder">
                            {state.loading ?
                                <img src={loader} className="loader" alt="loader" />
                                :
                                <Button type="submit" form="loginForm">
                                    Вход
                                </Button>
                            }
                        </div>
                    </form>
                </div>
            </main>
        </>
    );
}

export default Home;
